import lodash from 'lodash';
import { createColumnInlineCheckbox, createColumnInlineDate, createColumnInlineInput, createColumnInlineRadioGroup, createColumnInlineSelect, createColumnInlineTextArea, createColumnInput } from "../../../../components/table/c-table.logic";
import i18n from "../../../../i18n";
import store from "../../../../store";
import { createButtonCreate } from '../../../../utils/button';
import { onClickDeleteAllClient } from '../../../../utils/form';
import { createLoading } from '../../../../utils/loading';
import { has } from "../../../../utils/menu-context";
import { createManageDelete, createManageExportCsv, createPage, createRowActionDelete } from '../../../../utils/page';
import { Modal } from 'ant-design-vue';
import { clearRulesStartsWith } from '../../../../utils/validate';
// import { callSamplingMonitorType } from './sampling-monitor.section';

export const { isLoading, setIsLoading } = createLoading()

export const actionPrefix = 'resource/v1/transaction/samplingProduct'

export const callSearch = ({ criteria }) => store.dispatch(`${actionPrefix}/search`, { criteria })

export const callProvince = ({ searchQuery }) => store.dispatch('resource/v1/master/province/cacheFindAll', { name: searchQuery })
export const callCountry = ({ searchQuery }) => store.dispatch('resource/v1/master/country/cacheFindAll', { nameTh: searchQuery })
export const callAbNormalStatus = ({ searchQuery }) => store.dispatch('resource/v1/master/lookup/cacheFindAllByGroup', { group: 'AB_NORMAL_STATUS', value: searchQuery })
export const callSamplingMonitorProductByMonitorType = ({ monitorTypeId, searchQuery }) => store.dispatch('resource/v1/master/samplingMonitorProduct/findAllMonitorProductByMonitorType', { monitorTypeId , searchQuery })

export const createColumns = ({ props, data }) => {
    const { viewOnly, itemsKey, visibleSamplingRequest,

        visibleSamplingNo,
        visibleSamplingNameTh, visibleSamplingNameEn,
        visibleSamplingStoreDepartment, visibleSamplingPool, visibleProvince,
        visibleTransportNo, visibleBlNo, visibleBmdNo, visibleImdNo, visibleSourceProvince, visibleStorePlace, visibleLat, visibleLng,
        visibleFactoryName, visibleMfgDate, visibleSize, visibleLotNo, visibleTransportSourceCountry, visibleTransportDestinationCountry,
        visibleCountry1, visibleIsMicro, visibleIsChemi, visibleIsPhysic, visibleRequesterRemark, visibleProductQualityStatus,
        visibleOfficerAbnormalRemark,

        disabledSamplingNameTh, disabledSamplingNameEn, disabledSamplingMonitorProduct,
        disabledSamplingStoreDepartment, disabledSamplingPool, disabledProvince,
        disabledTransportNo, disabledBlNo, disabledBmdNo, disabledImdNo, disabledSourceProvince, disabledStorePlace, disabledLat, disabledLng,
        disabledFactoryName, disabledMfgDate, disabledSize, disabledLotNo, disabledTransportSourceCountry, disabledTransportDestinationCountry,
        disabledCountry1, disabledIsMicro, disabledIsChemi, disabledIsPhysic, disabledRequesterRemark, disabledProductQualityStatus,
        disabledOfficerAbnormalRemark,

    } = props
    const { useForm } = data
    const { modelRef } = useForm
    const items = itemsKey ? lodash.get(modelRef, itemsKey) : modelRef
    const columns = []
    if (visibleSamplingRequest) {
        columns.push(createColumnInput({ title: () => i18n.global.t("model.samplingRequest.requestNo"), dataIndex: "refSamplingRequest.requestNo" }))
    }
    columns.push(createColumnInput({
        visible: () => visibleSamplingNo,
        title: () => i18n.global.t("model.samplingProduct.samplingNo"),
        dataIndex: "samplingNo",
        align: 'center'
    }))
    columns.push(createColumnInlineInput({
        visible: () => visibleSamplingNameTh,
        title: () => i18n.global.t("model.samplingProduct.samplingNameTh"),
        dataIndex: "samplingNameTh",
        items,
        useForm,
        itemsKey,
        customRenderInputProp: () => ({ disabled: disabledSamplingNameTh || viewOnly })
    }))
    columns.push(createColumnInlineInput({
        visible: () => visibleSamplingNameEn,
        title: () => i18n.global.t("model.samplingProduct.samplingNameEn"),
        dataIndex: "samplingNameEn",
        items,
        useForm,
        itemsKey,
        customRenderInputProp: () => ({ disabled: disabledSamplingNameEn || viewOnly })
    }))
    columns.push(createColumnInlineSelect({
        title: () => i18n.global.t("model.samplingProduct.refSamplingMonitorProduct"),
        dataIndex: "refSamplingMonitorProduct",
        items,
        useForm,
        itemsKey,
        inputProp: () => ({ list: callSamplingMonitorProductByMonitorType({ monitorTypeId: modelRef.refSamplingMonitorType.id }) }),
        customRenderInputProp: () => {
            return {
                disabled: disabledSamplingMonitorProduct || viewOnly,
                list: ({searchQuery}) => callSamplingMonitorProductByMonitorType({ searchQuery, monitorTypeId: modelRef.refSamplingMonitorType.id }),
                renderLabel: ({ item }) => <span>{item.name}</span>
            }
        }
    }))
    columns.push(createColumnInlineInput({
        visible: () => visibleSamplingStoreDepartment,
        title: () => i18n.global.t("model.samplingProduct.samplingStoreDepartment"),
        dataIndex: "samplingStoreDepartment",
        items,
        useForm,
        itemsKey,
        customRenderInputProp: () => ({ disabled: disabledSamplingStoreDepartment || viewOnly })
    }))
    columns.push(createColumnInlineInput({
        visible: () => visibleSamplingPool,
        title: () => i18n.global.t("model.samplingProduct.samplingPool"),
        dataIndex: "samplingPool",
        items,
        useForm,
        itemsKey,
        customRenderInputProp: () => ({ disabled: disabledSamplingPool || viewOnly }),
        width: 75
    }))
    columns.push(createColumnInlineSelect({
        visible: () => visibleProvince,
        title: () => i18n.global.t("model.samplingProduct.refProvince"),
        dataIndex: "refProvince",
        items,
        useForm,
        itemsKey,
        inputProp: () => ({ list: callProvince }),
        customRenderInputProp: () => ({ disabled: disabledProvince || viewOnly, list: callProvince })
    }))
    columns.push(createColumnInlineInput({
        visible: () => visibleTransportNo,
        title: () => i18n.global.t("model.samplingProduct.transportNo"),
        dataIndex: "transportNo",
        items,
        useForm,
        itemsKey,
        customRenderInputProp: () => ({ disabled: disabledTransportNo || viewOnly })
    }))
    columns.push(createColumnInlineInput({
        visible: () => visibleBlNo,
        title: () => i18n.global.t("model.samplingProduct.blNo"),
        dataIndex: "blNo",
        items,
        useForm,
        itemsKey,
        customRenderInputProp: () => ({ disabled: disabledBlNo || viewOnly })
    }))
    columns.push(createColumnInlineInput({
        visible: () => visibleBmdNo,
        title: () => i18n.global.t("model.samplingProduct.bmdNo"),
        dataIndex: "bmdNo",
        items,
        useForm,
        itemsKey,
        customRenderInputProp: () => ({ disabled: disabledBmdNo || viewOnly })
    }))
    columns.push(createColumnInlineInput({
        visible: () => visibleImdNo,
        title: () => i18n.global.t("model.samplingProduct.imdNo"),
        dataIndex: "imdNo",
        items,
        useForm,
        itemsKey,
        customRenderInputProp: () => ({ disabled: disabledImdNo || viewOnly })
    }))
    columns.push(createColumnInlineSelect({
        visible: () => visibleSourceProvince,
        title: () => i18n.global.t("model.samplingProduct.refSourceProvince"),
        dataIndex: "refSourceProvince",
        items,
        useForm,
        itemsKey,
        inputProp: () => ({ list: callProvince }),
        customRenderInputProp: () => ({ disabled: disabledSourceProvince || viewOnly, list: callProvince })
    }))
    columns.push(createColumnInlineInput({
        visible: () => visibleStorePlace,
        title: () => i18n.global.t("model.samplingProduct.storePlace"),
        dataIndex: "storePlace",
        items,
        useForm,
        itemsKey,
        customRenderInputProp: () => ({ disabled: disabledStorePlace || viewOnly })
    }))
    columns.push(createColumnInlineInput({
        visible: () => visibleLat,
        title: () => i18n.global.t("model.samplingProduct.latStr"),
        dataIndex: "latStr",
        items,
        useForm,
        itemsKey,
        customRenderInputProp: () => ({ disabled: disabledLat || viewOnly })
    }))
    columns.push(createColumnInlineInput({
        visible: () => visibleLng,
        title: () => i18n.global.t("model.samplingProduct.lngStr"),
        dataIndex: "lngStr",
        items,
        useForm,
        itemsKey,
        customRenderInputProp: () => ({ disabled: disabledLng || viewOnly })
    }))
    columns.push(createColumnInlineInput({
        visible: () => visibleFactoryName,
        title: () => i18n.global.t("model.samplingProduct.factoryName"),
        dataIndex: "factoryName",
        items,
        useForm,
        itemsKey,
        customRenderInputProp: () => ({ disabled: disabledFactoryName || viewOnly })
    }))
    columns.push(createColumnInlineDate({
        visible: () => visibleMfgDate,
        title: () => i18n.global.t("model.samplingProduct.mfgDate"),
        dataIndex: "mfgDate",
        items,
        useForm,
        itemsKey,
        customRenderInputProp: () => ({ disabled: disabledMfgDate || viewOnly })
    }))
    columns.push(createColumnInlineInput({
        visible: () => visibleSize,
        title: () => i18n.global.t("model.samplingProduct.size"),
        dataIndex: "size",
        items,
        useForm,
        itemsKey,
        customRenderInputProp: () => ({ disabled: disabledSize || viewOnly })
    }))
    columns.push(createColumnInlineInput({
        visible: () => visibleLotNo,
        title: () => i18n.global.t("model.samplingProduct.lotNo"),
        dataIndex: "lotNo",
        items,
        useForm,
        itemsKey,
        customRenderInputProp: () => ({ disabled: disabledLotNo || viewOnly })
    }))
    columns.push(createColumnInlineSelect({
        visible: () => visibleTransportSourceCountry,
        title: () => i18n.global.t("model.samplingProduct.refTransportSourceCountry"),
        dataIndex: "refTransportSourceCountry",
        items,
        useForm,
        itemsKey,
        inputProp: () => ({ list: callCountry, optLabel: 'nameTh' }),
        customRenderInputProp: () => ({ disabled: disabledTransportSourceCountry || viewOnly, list: callCountry, optLabel: 'nameTh' })
    }))
    columns.push(createColumnInlineSelect({
        visible: () => visibleTransportDestinationCountry,
        title: () => i18n.global.t("model.samplingProduct.refTransportDestinationCountry"),
        dataIndex: "refTransportDestinationCountry",
        items,
        useForm,
        itemsKey,
        inputProp: () => ({ list: callCountry, optLabel: 'nameTh' }),
        customRenderInputProp: () => ({ disabled: disabledTransportDestinationCountry || viewOnly, list: callCountry, optLabel: 'nameTh' })
    }))
    columns.push(createColumnInlineSelect({
        visible: () => visibleCountry1,
        title: () => i18n.global.t("model.samplingProduct.exportCountry"),
        dataIndex: "refCountry1",
        items,
        useForm,
        itemsKey,
        inputProp: () => ({ list: callCountry, optLabel: 'nameTh' }),
        customRenderInputProp: () => ({ disabled: disabledCountry1 || viewOnly, list: callCountry, optLabel: 'nameTh' })
    }))
    columns.push(createColumnInlineCheckbox({
        visible: () => visibleIsMicro,
        title: () => i18n.global.t("model.samplingProduct.isMicro"),
        dataIndex: "isMicro",
        items,
        useForm,
        itemsKey,
        customRenderInputProp: ({record}) => ({ disabled: disabledIsMicro || viewOnly || record.refProductQualityStatus?.key == 'AN' })
    }))
    columns.push(createColumnInlineCheckbox({
        visible: () => visibleIsChemi,
        title: () => i18n.global.t("model.samplingProduct.isChemi"),
        dataIndex: "isChemi",
        items,
        useForm,
        itemsKey,
        customRenderInputProp: ({record}) => ({ disabled: disabledIsChemi || viewOnly || record.refProductQualityStatus?.key == 'AN' })
    }))
    columns.push(createColumnInlineCheckbox({
        visible: () => visibleIsPhysic,
        title: () => i18n.global.t("model.samplingProduct.isPhysic"),
        dataIndex: "isPhysic",
        items,
        useForm,
        itemsKey,
        customRenderInputProp: ({record}) => ({ disabled: disabledIsPhysic || viewOnly || record.refProductQualityStatus?.key == 'AN' })
    }))
    columns.push(createColumnInlineTextArea({
        visible: () => visibleRequesterRemark,
        title: () => i18n.global.t("model.samplingProduct.requesterRemark"),
        dataIndex: "requesterRemark",
        items,
        useForm,
        itemsKey,
        customRenderInputProp: () => ({ disabled: disabledRequesterRemark || viewOnly })
    }))
    columns.push(createColumnInlineRadioGroup({
        visible: () => visibleProductQualityStatus,
        title: () => i18n.global.t("model.samplingProduct.refProductQualityStatus"),
        dataIndex: "refProductQualityStatus",
        items,
        useForm,
        itemsKey,
        inputProp: () => ({ list: callAbNormalStatus, optLabel: 'value' }),
        customRenderInputProp: ({ record }) => ({
            disabled: disabledProductQualityStatus || viewOnly,
            list: callAbNormalStatus,
            optLabel: 'value',
            'onUpdate:value': (value) => {
                record.isSave = true
                record.refProductQualityStatus = value
                if (value?.key === 'N') {
                    record.officerAbnormalRemark = null
                } else if (value?.key === 'AN') {
                    record.isMicro = false;
                    record.isChemi = false;
                    record.isPhysic = false;
                }
            }
        }),
        fixed: 'right',
    }))
    columns.push(createColumnInlineTextArea({
        visible: () => visibleOfficerAbnormalRemark,
        title: () => i18n.global.t("model.samplingProduct.officerAbnormalRemark"),
        dataIndex: "officerAbnormalRemark",
        items,
        useForm,
        itemsKey,
        customRenderInputProp: ({ record }) => ({ disabled: disabledOfficerAbnormalRemark || viewOnly || record.refProductQualityStatus?.key !== 'AN' }),
        fixed: 'right',
    }))
    return columns
}

export const initData = ({ props, data }) => {
    const { menuContext, viewOnly, itemsKey, dataProp } = props
    const { useForm } = data
    const { modelRef } = useForm
    const items = itemsKey ? lodash.get(modelRef, itemsKey) : modelRef
    data.columns = createColumns({ props, data })
    data.page = createPage({ data: items })
    data.tableOptions = { search: { activeKey: null } }
    data.manages = [
        createManageDelete({
            menuContext,
            visible: () => viewOnly ? false : has({ menuContext, key: 'canDelete' }),
            onClick: ({ rowSelection }) => onClickDeleteAllClient({ rowSelection, useForm, items, key: itemsKey }),
        }),
        createManageExportCsv({ menuContext }),
    ]
    data.manageExtras = []
    data.rowActions = []
    const canDeleteChecker = !dataProp?.useForm?.modelRef?.id || ['Draft', 'Reject'].includes(dataProp?.useForm?.modelRef?.refSamplingStatus?.key)
    if (canDeleteChecker) {
        data.rowActions.push(createRowActionDelete({
            menuContext,
            onClick: ({ record }) => {
                Modal.confirm({
                    title: i18n.global.t("components.table.operatorAndPagination.youAreWant", { text: i18n.global.t("button.delete") }),
                    autoFocusButton: "cancel",
                    okType: "danger",
                    onOk: () => {
                        clearRulesStartsWith({ useForm, key: itemsKey })
                         onClickDeleteAllClient({ rowSelection: { selectedRows: [record] }, items: items })
                    }
                });
            }
        }));
    }

    if (!viewOnly) {
        data.manageExtras.push({
            render: () => ({
                ...createButtonCreate({
                    onClick: () => items.push({}),
                    options: { text: i18n.global.t('views.samplingMonitor.samplingMonitorProduct.title') }
                }),
            }),
            visible: () => has({ menuContext, key: 'canCreate' }),
        })
    }

    fetchData({ props, data }).then(page => items.push(...page.data))
}

export const fetchData = ({ props }) => {
    const { fetchCriteria } = props
    if (!fetchCriteria || fetchCriteria.fetched) {
        return Promise.resolve({ data: [] })
    }
    fetchCriteria.fetched = true
    setIsLoading(true)
    return callSearch({ criteria: fetchCriteria }).finally(() => setIsLoading(false))
}
